await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false);

class VariantBtn extends McElement {
    connectedCallback() {
      this.addEventListener('click', this._onClick.bind(this));
    }

    _onClick(event) {
      event.preventDefault();

      if(!this.dataset.url) {
          console.error('VariantBtn: No URL found for variant button');
          return;
      }
      
      // Rimuovi la classe active da tutti i variant-btn
      document.querySelectorAll('variant-btn').forEach(btn => {
          btn.classList.remove('border', 'border-3', 'border-primary');
      });
      
      // Aggiungi la classe active al pulsante cliccato
      this.classList.add('border', 'border-3', 'border-primary');
      
      McShopify.customEvent('variant:select', {
          url: this.dataset.url
      });
    }
}

if (!customElements.get('variant-btn')) {
    customElements.define('variant-btn', VariantBtn);
}
window.VariantBtn = VariantBtn;
